import { loadSchemaOwnershipIndex } from './load-schema-ownership-index.js'
import { saveSchemaOwnershipIndex } from './save-schema-ownership-index.js'

export function removeSchemaOwner(cwd: string, schemaName: string): void {
  const index = loadSchemaOwnershipIndex(cwd)
  delete index.schemas[schemaName]
  saveSchemaOwnershipIndex(cwd, index)
}
